import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { User } from '../types';
import { UserUrl } from './UserUrl';
import { UserSchema } from '../schema';

const getUser = ({ id, lock }: { id: number; lock?: boolean }) =>
  apiClient
    .get<User>(expand(UserUrl.USER, { id, lock }))
    .then((response) => UserSchema.parseFormData(response.data));

export const useUserEditQuery = createApiQueryHook(['user'], getUser);
